import React, { useState, useEffect } from "react";
import "./Navbar.css";

export default function Navbar({ searchQuery, onSearchQueryChange }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 50);
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function closeMenu() {
    setMenuOpen(false);
  }

  return (
    <nav className={`navbar ${scrolled ? "navbar--scrolled" : ""}`}>
      {/* Logo */}
      <div className="nav-logo">
        <svg className="nav-logo-icon" viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="20" r="19" stroke="#1a4a2e" strokeWidth="1.5" />
          <ellipse
            cx="12"
            cy="26"
            rx="7"
            ry="4"
            fill="#e07b39"
            transform="rotate(-30 12 26)"
          />
          <ellipse
            cx="28"
            cy="26"
            rx="7"
            ry="4"
            fill="#e07b39"
            transform="rotate(30 28 26)"
          />
          <path d="M20 24 L16 18 L20 10 L24 18 Z" fill="#1a4a2e" />
          <circle cx="20" cy="9" r="3" fill="#e07b39" />
        </svg>
        <div className="nav-logo-text">
          <span className="nav-logo-brand">SWATHI'S</span>
          <span className="nav-logo-sub">We BetterR Wellness</span>
        </div>
      </div>

      <div className="nav-search-wrap">
        <input
          className="nav-search"
          type="search"
          value={searchQuery}
          onChange={(e) => onSearchQueryChange(e.target.value)}
          placeholder="Search products..."
          aria-label="Search products"
        />
      </div>

      {/* Desktop Links */}
      <ul className="nav-links">
        <li>
          <a href="#ingredients" onClick={closeMenu}>
            Ingredients
          </a>
        </li>
        <li>
          <a href="#benefits" onClick={closeMenu}>
            Benefits
          </a>
        </li>
        <li>
          <a href="#how-to-use" onClick={closeMenu}>
            How to Use
          </a>
        </li>
        <li>
          <a href="#weight-loss" onClick={closeMenu}>
            Weight Loss
          </a>
        </li>
        <li>
          <a href="#detox" onClick={closeMenu}>
            Detox
          </a>
        </li>
        <li>
          <a href="#order" className="nav-cta" onClick={closeMenu}>
            Order Now
          </a>
        </li>
      </ul>

      {/* Mobile Action Buttons */}
      <div className="mobile-nav-pills">
        <a href="#weight-loss" className="mobile-nav-pill" onClick={closeMenu}>
          <div className="circle-icon">
            <svg viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="18" stroke="#1a4a2e" strokeWidth="1.5" />
              <path d="M20 10 L24 18 L20 24 L16 18 Z" fill="#1a4a2e" />
              <circle cx="20" cy="9" r="2.5" fill="#e07b39" />
            </svg>
          </div>
          <span className="circle-label">Weight Loss</span>
        </a>
        <a href="#detox" className="mobile-nav-pill" onClick={closeMenu}>
          <div className="circle-icon">
            <svg viewBox="0 0 40 40" fill="none">
              <circle cx="20" cy="20" r="18" stroke="#1a4a2e" strokeWidth="1.5" />
              <path d="M20 10 C24 12 25 16 24 20 C23 24 20 27 20 27 C20 27 17 24 16 20 C15 16 16 12 20 10 Z" fill="#1a4a2e" />
              <circle cx="20" cy="9" r="2.5" fill="#e07b39" />
            </svg>
          </div>
          <span className="circle-label">Detox</span>
        </a>
      </div>

      {/* Hamburger */}
      <button
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="mobile-menu">
          <div className="mobile-search-wrap">
            <input
              className="nav-search mobile-search"
              type="search"
              value={searchQuery}
              onChange={(e) => onSearchQueryChange(e.target.value)}
              placeholder="Search products..."
              aria-label="Search products"
            />
          </div>
          <a href="#ingredients" onClick={closeMenu}>
            Ingredients
          </a>
          <a href="#benefits" onClick={closeMenu}>
            Benefits
          </a>
          <a href="#how-to-use" onClick={closeMenu}>
            How to Use
          </a>
          <a href="#weight-loss" onClick={closeMenu}>
            Weight Loss
          </a>
          <a href="#order" className="nav-cta" onClick={closeMenu}>
            Order Now
          </a>
        </div>
      )}
    </nav>
  );
}
